import React, { Fragment, useState } from 'react'
import styled from 'styled-components'

import { useScrollEnd } from 'hooks'

import { ContentBox, Flex, DesktopOnly } from 'ui/acro'

import SubmitButton from './SubmitButton'

const MobileSubmitWrapper = styled(Flex)((props) => ({
  position: 'fixed',
  bottom: 0,
  left: 0,
  background: props.theme.colors.base,
  justifyContent: 'center',
  width: '100%',
  padding: '19px 0',
  boxShadow: `0px 19px 38px rgba(${props.theme.colors.rgb.primary}, 0.28)`,
  borderTop: `1px solid ${props.theme.colors.grey1}`,
  textAlign: 'center',
  zIndex: '10'
}))

const DesktopSubmitWrapper = styled.div((props) => ({
  position: 'fixed',
  bottom: 0,
  background: props.theme.colors.base,
  width: 'calc(50% - 75px)',
  paddingBottom: '70px',
  boxShadow: `0px 0px 50px 50px rgba(${props.theme.colors.rgb.base}, 1)`,
  transition: 'all 0.5s ease',
  textAlign: 'center',
  marginLeft: '-4px',

  '&.scroll-end': {
    boxShadow: 'none'
  }
}))

const SubmitContainer = () => {
  const [scrollClass, setScrollClass] = useState('')

  // Hide gradient box-shadow on desktop when at end of scroll
  useScrollEnd(
    () => setScrollClass('scroll-end'),
    () => setScrollClass('')
  )

  //////////////////////////////////////////////////

  return (
    <Fragment>
      {/* Desktop */}
      <DesktopOnly>
        <DesktopSubmitWrapper className={scrollClass}>
          <SubmitButton />
        </DesktopSubmitWrapper>
      </DesktopOnly>

      {/* Mobile/tablet */}
      <MobileSubmitWrapper display={['flex', 'flex', 'none']}>
        <ContentBox>
          <SubmitButton />
        </ContentBox>
      </MobileSubmitWrapper>
    </Fragment>
  )
}

export default SubmitContainer
